var localizedDetails = function() {
	var color = "colour";
	var colorCap = "Colour";
	var invalidQuestionMsg = "Questions need to be longer than 5 characters!";
	var invalidAnswerMsg = "Answers must be longer than 1 character!";
	var phoneNumber = '1890 98 74 44';
	var showCustomerImages = false;
	return {
		Color: color,
		ColorCap: colorCap,
		InvalidQuestionMsg: invalidQuestionMsg,
		InvalidAnswerMsg: invalidAnswerMsg,
		PhoneNumber: phoneNumber,
		showCustomerImages: showCustomerImages
	};
};